import React, { ReactNode, useEffect, useMemo, useState } from 'react';
import { ThemeProvider } from '@emotion/react';
import { skymindTheme, validaideTheme } from 'Contexts/ThemeContext/themes';

enum AppTheme {
    VALIDAIDE,
    SKYMIND
}
type ThemeContextWrapperProps = {
    children: ReactNode
}
const preloadedTheme = new URLSearchParams(window.location.search)
    .get('preloadedTheme');

const ThemeContextWrapper = ({
    children,
}:ThemeContextWrapperProps) => {
    const [appTheme, setAppTheme] = useState<AppTheme>(AppTheme.SKYMIND);

    useEffect(() => {
        if (preloadedTheme) {
            switch (preloadedTheme.toLowerCase()) {
            case 'validaide':
                setAppTheme(AppTheme.VALIDAIDE);
                break;
            case 'skymind':
            default:
                setAppTheme(AppTheme.SKYMIND);
                break;
            }
        }
    }, [preloadedTheme]);
    const theme = useMemo(() => {
        switch (appTheme) {
        case AppTheme.VALIDAIDE:
            return validaideTheme;
        case AppTheme.SKYMIND:
        default:
            return skymindTheme;
        }
    }, [appTheme]);

    return (
        <ThemeProvider theme={theme as any}>
            {children}
        </ThemeProvider>
    );
};

export default ThemeContextWrapper;
